import React from 'react';
import { string, bool } from 'prop-types';

const Subtitle = ({
    src,
    label,
    srcLang,
    active = false
}) => (
    <track label={label}
        srcLang={srcLang}
        src={src}
        default={active}
        kind="subtitles"/>
);

Subtitle.propTypes = {
    src: string,
    label: string,
    srcLang: string,
    active: bool
};

export default Subtitle;
